import { animated, useTransition } from 'react-spring';
import React__default, { useState } from 'react';
import { Toast } from './Toast.es.js';
import styled from '@emotion/styled';
import { uid } from '../../../helpers/utils.es.js';

const ToastContextDesktop = React__default.createContext({});
const toastPlacement = [
    'topLeft',
    'topRight',
    'bottomLeft',
    'bottomRight',
];
const ToastProviderDesktop = ({ children, }) => {
    const [toastPlacementState, setToastPlacementState] = useState({
        topLeft: [],
        topRight: [],
        bottomLeft: [],
        bottomRight: [],
    });
    const transitionConfig = { tension: 125, friction: 20, precision: 0.1 };
    const toastTransitions = {
        topRight: useTransition(toastPlacementState.topRight, {
            from: { opacity: 0, transform: 'translate(40px, 0px)' },
            enter: { opacity: 1, transform: 'translate(0px, 0px)' },
            leave: { opacity: 0, transform: 'translate(0px, -10px)' },
            config: transitionConfig,
        }),
        bottomRight: useTransition(toastPlacementState.bottomRight, {
            from: { opacity: 0, transform: 'translate(40px, 0px)' },
            enter: { opacity: 1, transform: 'translate(0px, 0px)' },
            leave: { opacity: 0, transform: 'translate(0px, 10px)' },
            config: transitionConfig,
        }),
        topLeft: useTransition(toastPlacementState.topLeft, {
            from: { opacity: 0, transform: 'translate(-40px, 0px)' },
            enter: { opacity: 1, transform: 'translate(0px, 0px)' },
            leave: { opacity: 0, transform: 'translate(0px, -10px)' },
            config: transitionConfig,
        }),
        bottomLeft: useTransition(toastPlacementState.bottomLeft, {
            from: { opacity: 0, transform: 'translate(-40px, 0px)' },
            enter: { opacity: 1, transform: 'translate(0px, 0px)' },
            leave: { opacity: 0, transform: 'translate(0px, 10px)' },
            config: transitionConfig,
        }),
    };
    const open = (props) => {
        const toastPlacement = props.placement || 'topRight';
        if (toastPlacement === 'topLeft' || toastPlacement === 'topRight') {
            setToastPlacementState((state) => (Object.assign(Object.assign({}, state), { [toastPlacement]: [...state[toastPlacement], Object.assign(Object.assign({}, props), { id: uid() })] })));
            return;
        }
        setToastPlacementState((state) => (Object.assign(Object.assign({}, state), { [toastPlacement]: [Object.assign(Object.assign({}, props), { id: uid() }), ...state[toastPlacement]] })));
    };
    const onClose = (placement, item) => {
        setToastPlacementState((state) => (Object.assign(Object.assign({}, state), { [placement]: state[placement].filter((e) => e.id !== item.id) })));
    };
    const toast = {
        open,
    };
    ['success', 'info', 'error', 'warning'].forEach((type) => {
        toast[type] = (props) => open(Object.assign({ type }, props));
    });
    return (React__default.createElement(ToastContextDesktop.Provider, { value: toast },
        children,
        toastPlacement.map((place) => {
            var _a;
            if (!((_a = toastPlacementState[place]) === null || _a === void 0 ? void 0 : _a.length))
                return;
            const placementCls = `teko-toast teko-toast-${place}`;
            return (React__default.createElement(ToastPositionGroup, { key: place, className: placementCls }, toastTransitions[place]((style, item) => {
                return (React__default.createElement(AnimatedDiv, { key: item.id, style: style },
                    React__default.createElement(Toast, Object.assign({}, item, { onClose: () => onClose(place, item) }))));
            })));
        })));
};
const ToastPositionGroup = styled.div `
  &.teko-toast {
    position: fixed;
    z-index: 1070;
    &.teko-toast-topRight {
      right: 24px;
      top: 24px;
    }
    &.teko-toast-topLeft {
      left: 24px;
      top: 24px;
    }
    &.teko-toast-bottomLeft {
      left: 24px;
      bottom: 24px;
    }
    &.teko-toast-bottomRight {
      right: 24px;
      bottom: 24px;
    }
  }
`;
const AnimatedDiv = styled(animated.div) `
  margin-bottom: 16px;
`;

export { ToastContextDesktop, ToastProviderDesktop, toastPlacement };
